import React, { ReactNode } from 'react'

interface AdminContainerProps {
  children?: ReactNode; // ReactNode is the type for any React elements passed as children
  className?: string;   // Optional className prop
}
const Cointainer:React.FC<AdminContainerProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`bg-white p-2 rounded-[20px]  ${className}`}
    >
      {children}
    </div>
  )
}

export default Cointainer
